export const ENROLLMENTS_4_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_priority: 1,
    meta_status: true,
    meta_icon: "",
    meta_icon_alt: "",
    meta_title: "100% Online",
    meta_description: "Learn at your own pace, anywhere in the world.",
    meta_front_background_color: "#FFFFFF",
    meta_front_text_color: "#0A0A0A",
    meta_back_background_color: "#DB5803",
    meta_back_text_color: "#FFFFFF",
  },

  METADATA_TITLES: {
    metadata: "Flip Cards",
  },

  ENROLLMENTS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title (wrap highlight in { } e.g. Key {advantages})",
      value: "Key {advantages} of this programme",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Key {advantages} of this programme",
      required: false,
      defaultValue: "Key {advantages} of this programme",
      rows: 2,
    },
    {
      fieldName: "cta_label",
      label: "Button label",
      value: "Get Started",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Get Started",
      required: false,
      defaultValue: "Get Started",
    },
    {
      fieldName: "cta_url",
      label: "Button URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/path or https:// — used when 'Open lead popup' is off",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "open_in_new_tab",
      label: "Open link in new tab",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "enable_lead_popup",
      label: "Is CTA — open lead popup",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = lead capture popup instead of button URL",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "desktop_image",
      label: "Desktop background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Mobile background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile background image (falls back to desktop)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Section background color (fallback if no image)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_color",
      label: "Title color",
      value: "#0A0A0A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#0A0A0A",
      required: false,
      defaultValue: "#0A0A0A",
    },
    {
      fieldName: "title_highlight_color",
      label: "Title highlight color (for {...} text)",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "cta_background_color",
      label: "Button background",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "cta_text_color",
      label: "Button text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Sort order (1, 2, 3…)",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide this card",
      defaultValue: true,
    },
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (front face)",
    },
    {
      header: "Icon alt text",
      fieldName: "meta_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Icon alt text",
    },
    {
      header: "Front title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Short label shown on the card front",
    },
    {
      header: "Back description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Detail shown on the card back",
      rows: 3,
    },
    {
      header: "Front background color",
      fieldName: "meta_front_background_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Front text color",
      fieldName: "meta_front_text_color",
      value: "#0A0A0A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#0A0A0A",
      defaultValue: "#0A0A0A",
    },
    {
      header: "Back background color",
      fieldName: "meta_back_background_color",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      defaultValue: "#DB5803",
    },
    {
      header: "Back text color",
      fieldName: "meta_back_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      defaultValue: "#FFFFFF",
    },
  ],
};
